export const adapter = async <T>(
  url: string,
  options: RequestInit
): Promise<T> => {
  const request = new Request(
    import.meta.env.VITE_SERVICE_KEYWORDS_URL + url,
    options
  );
  const response = await fetch(request);
  const data = await response.json();

  return {
    status: response.status,
    data,
  } as T;
};
